var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _c(
      "label",
      {
        staticClass: "trbo-a-input-item__label",
        attrs: { for: "label-" + _vm._uid },
      },
      [_vm._v(_vm._s(_vm.input.label))]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "trbo-a-input-item__content" }, [
      _c(
        "input",
        _vm._b(
          {
            staticClass: "trbo-a-input-item__input",
            attrs: {
              id: "label-" + _vm._uid,
              placeholder: _vm.input.placeholder,
              "aria-invalid": _vm.ariaInvalid,
            },
            domProps: { value: _vm.value },
            on: { input: _vm.handleChange, invalid: _vm.handleInvalid },
          },
          "input",
          _vm.inputAttributes,
          false
        )
      ),
      _vm._v(" "),
      _vm.icon
        ? _c(
            "div",
            { staticClass: "trbo-a-input-item__icon" },
            [
              _c("icon", {
                staticClass: "trbo-a-input-item__icon__image",
                attrs: { name: _vm.icon },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }